import { Component } from 'react'
import PropTypes from 'prop-types'

import './Popup.scss'

class Popup extends Component {
  static propTypes = {
    visible: PropTypes.bool
  }

  static defaultProps = {
    className: '',
    visible: false,
  }

  render() {
    return (
      <div className={`popup ${this.props.visible ? 'visible' : ''} ${this.props.className}`}>
        <div className="popup-window">
          {this.props.children}
        </div>
      </div>
    )
  }

}

export default Popup